// ============================================================
// Biens Saisis - Dashboard Data & Utils
// ============================================================

// import dashboardService from "../../services/DashboardService";

// Label translation map
const labelMap = {
    // Gestion Effective
    bienAVendre: 'Biens à vendre',
    bienDormant: 'Biens dormants',
    bienAffecte: 'Biens affectés',
    bienConserveDansUnEntrepot: 'Conservés en entrepôt',
    bienADetruire: 'Biens à détruire',
    bienConserveDansUnCoffrefort: 'Conservés en coffre-fort',
    // Natures
    'Biens meubles corporels': 'Biens meubles corporels',
    'Biens meubles incorporels': 'Biens meubles incorporels',
    'Non Bâtis': 'Non bâtis',
    'Bâtis': 'Bâtis',
    // Types
    Meubles: 'Meubles',
    Immeubles: 'Immeubles',
    // Statuts Gestion
    enAttente: 'En attente',
    enGestion: 'En gestion',
    // Etats
    nonRecouvre: 'Non recouvré',
    recouvre: 'Recouvré',
    nonRecouvrable: 'Non recouvrable',
    // Statuts Procédure
    saisie: 'Saisie',
    confisqueProvisoire: 'Confisqué (prov.)',
    restitue: 'Restitué',
    confisqueDefinitif: 'Confisqué (déf.)',
    // Etats Finaux
    indisponible: 'Indisponible',
    vendu: 'Vendu',
    affecte: 'Affecté',
    conserve: 'Conservé',
    personneMorale: 'Personne morale',
    personnePhysique: 'Personne physique',

    // Statut de dossier
    CONFIRME: 'Dossier Confirmé',
    BROUILLON: 'Dossier Brouillon',
    TERMINE: 'Dossier Terminé',
    ANNULE: 'Dossier Annulé',

    // Statut de facture (exactement comme le Backend Spring Boot)
    PAYEE: 'Facture Payée',
    EMISE: 'Facture Émise',
    PARTIELLEMENT_PAYEE: 'Facture Partiellement Payée',
    EN_RETARD: 'En retard',

    // Si jamais vous avez d'autres modules qui l'envoient au masculin, 
    // vous pouvez garder les deux :
    PAYE: 'Paiement Payé',
    EMIS: 'Facture Émise',
    PARTIELLEMENT_PAYE: 'Paiement Partiellement Payé',
};

export function translateLabel(key) {
    if (!key) return 'Inconnu';
    return labelMap[key] || key;
}

// export const dashboardData = dashboardService.statistiquesBien();

export const CHART_COLORS = [
    '#c9a84c', // gold
    '#1a1a2e', // ink
    '#2e7d32', // green
    '#c62828', // red
    '#1565c0', // blue
    '#ef6c00', // orange
    '#6a1b9a', // purple
    '#00838f', // teal
    '#4e342e', // brown
    '#37474f', // dark gray
    '#827717', // olive
    '#ad1457', // pink
    '#006064', // dark teal
    '#ff8f00', // amber
    '#1b5e20', // dark green
    '#283593', // dark blue
    '#bf360c', // dark orange
];

export function formatNumber(n) {
    // Conversion explicite en Number au cas où 'n' serait envoyé sous forme de chaîne ('8799')
    return Number(n).toLocaleString('fr-FR');
}